import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Partner } from './partner.model';

@Injectable()
export class PartnerService {
    constructor(private http: HttpClient) {}

    getResourceUrl() {
        return '/api/partners';
    }

    create(modelElement) {
        return this.http.post<any>(this.getResourceUrl(), modelElement);
    }

    update(modelElement): Observable<any> {
        return this.http
            .put(`${this.getResourceUrl()}/${modelElement.id}`, modelElement)
            .pipe(
                catchError((error: any) =>
                    observableThrowError(extractErrorDescription(error))
                )
            );
    }

    remove(modelElement) {
        return this.http.delete(this.getResourceUrl() + '/' + modelElement.id);
    }

    findAll(): Observable<Partner[]> {
        return this.http.get<Partner[]>(this.getResourceUrl());
    }

    findById(id): Observable<Partner> {
        return this.http.get<Partner>(this.getResourceUrl() + '/' + id);
    }

    resetPicture(modelElement): Observable<Response> {
        return this.http.delete<Response>(
            ` ${this.getResourceUrl()}/${modelElement.id} /picture`,
            {}
        );
    }

    uploadPicture(partnerId, file) {
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post(`/api/partners/${partnerId}/picture`, formData);
    }
}

function extractErrorDescription(error: any) {
    return error.message || 'Server error';
}



// WEBPACK FOOTER //
// ./src/app/_services/partner/partner.service.ts